'use es6';

import getIn from 'transmute/getIn';
import { getMessages } from './getters';
export const getMessageFromThreadHistory = (messageId, threadHistory) => {
  return getIn([messageId], getMessages(threadHistory));
};